var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.167 4.583V9.25a1.167 1.167 0 0 0 1.167 1.167h3.5M5.167 4.583V3.417A1.167 1.167 0 0 1 6.334 2.25h2.675c.155 0 .303.062.413.17l2.574 2.576c.11.11.171.257.171.412V9.25a1.167 1.167 0 0 1-1.166 1.167H9.834M5.167 4.583H4.001A1.167 1.167 0 0 0 2.834 5.75v5.833a1.167 1.167 0 0 0 1.167 1.167h4.666a1.167 1.167 0 0 0 1.167-1.167v-1.166",
    stroke: "#9CA3AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.19b0c87d83899dfce671114267f88a2b.svg";
export { ForwardRef as ReactComponent };